import { Injectable } from '@angular/core';
import { IMemberKeyEvent, IMemberKeyValueDto, IMemberKeyValueList, kvpMemberEventType } from 'src/app/models/keyvalue';
import { AbstractDataContext } from 'src/app/shared/data-context-repository/data-context.models';
import { Utilities } from '../utilities';
import { KvpManagerEndpointService } from './kvp-manager-endpoint';

@Injectable({
  providedIn: 'root'
})
export class KvpManagerService  extends AbstractDataContext<IMemberKeyEvent>{

  memberKeyValues: IMemberKeyValueDto[] = [];

  static readonly contextId = `app.member.kvpData`;

  constructor(private kvpManagerEndpointService: KvpManagerEndpointService) {
    super(KvpManagerService.contextId);
   }

  handleEvent(event: IMemberKeyEvent): void {
    this.bucket.saveContextData(this.id, event);
    console.log('event => ', event);
  }

  sendEvent(type: kvpMemberEventType, kvPairs: IMemberKeyValueDto[]) {
    const event: IMemberKeyEvent = {
        id: this.id,
        MemberKeyValueDto: Utilities.cloneHard(kvPairs)
    };

    this.handleEvent(event);
  }

  public async addMemberKVPair(tenantId: string, memberId: string, request: IMemberKeyValueList) {
    
    await this.kvpManagerEndpointService.updateMemberKVPair(tenantId, memberId, request);

    request.Keys.forEach(kvp => {
      this.updateMemberKeyValue(kvp);
    });

    this.sendEvent(kvpMemberEventType.valueUpdate, this.memberKeyValues);
  }

  public async updateMemberKVPair(tenantId: string, memberId: string, request: IMemberKeyValueList) {
    
    let status = await this.kvpManagerEndpointService.updateMemberKVPair(tenantId, memberId, request);

    request.Keys.forEach(kvp => {
      this.updateMemberKeyValue(kvp);
    });

    this.sendEvent(kvpMemberEventType.valueUpdate, this.memberKeyValues);
  }

  public async getAllMemberKVPairs(tenantId: string, memberId: string): Promise<IMemberKeyValueDto[]> {

    this.memberKeyValues = await this.kvpManagerEndpointService.getMemberKVPairs(tenantId, memberId).toPromise();
    this.sendEvent(kvpMemberEventType.valueUpdate, this.memberKeyValues);
    return this.memberKeyValues;
  }

  public async getMemberKVPair(tenantId: string, memberId: string, key: string): Promise<IMemberKeyValueDto> {
    let kvp: IMemberKeyValueDto = await this.kvpManagerEndpointService.getMemberKVPair(tenantId, memberId, key).toPromise();
    this.updateMemberKeyValue(kvp);
    this.sendEvent(kvpMemberEventType.valueUpdate, this.memberKeyValues);
    return this.memberKeyValues.find(kvp=> kvp.key == key);
  }

  private updateMemberKeyValue(kvpUpdate: IMemberKeyValueDto) {
    const index = this.memberKeyValues.findIndex(kvp=> kvp.key == kvpUpdate.key);
    (index != -1) ? this.memberKeyValues.splice(index, 1, kvpUpdate) : this.memberKeyValues.push(kvpUpdate);
  }
}
